import pino, { Logger, LoggerOptions } from "pino";
import { isNextClient } from "@/utils/uaParser";
import sgmManager from "@/utils/sgmUtils";

const pinoOption: LoggerOptions = {
  timestamp: () => `,"time":"${new Date().toISOString()}"`,
};

// 因为行云限制，目录文件需要放到/export/Logs/下，所以需要判断环境
const logDestination = process.env.NEXT_PUBLIC_APP_ENV === "development" ? "app.log" : "/export/Logs/app.log";

// 判断是否在 build 阶段，避免 build 报错
const isBuilding = process.env.npm_lifecycle_event?.startsWith("build");

// 服务器端 Logger
let serverLogger: Logger | undefined;

// 仅在非 build 阶段且 pino.destination 存在时初始化 serverLogger
if (!isBuilding && pino.destination) {
  serverLogger = pino(pinoOption, pino.destination(logDestination));
}

// 浏览器端自定义 Logger
const clientLogger = {
  info: (args: any) => {
    sgmManager.infoLog(args);
  },
  error: (args: any) => {
    sgmManager.errorLog(args);
  },
};

export const logger = isNextClient() ? clientLogger : serverLogger ?? console;
